import revive_payload_client_4sVQNw7RlN from "/root/code-vivasport/vs2-front/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/root/code-vivasport/vs2-front/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/root/code-vivasport/vs2-front/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/root/code-vivasport/vs2-front/node_modules/nuxt/dist/app/plugins/payload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/root/code-vivasport/vs2-front/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import components_plugin_KR1HBZs4kY from "/root/code-vivasport/vs2-front/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/root/code-vivasport/vs2-front/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import pwa_icons_plugin_LnrhIJeMG7 from "/root/code-vivasport/vs2-front/.nuxt/pwa-icons-plugin.ts";
import plugin_ghbUAjaD3n from "/root/code-vivasport/vs2-front/node_modules/@nuxtjs/device/dist/runtime/plugin.js";
import i18n_yfWm7jX06p from "/root/code-vivasport/vs2-front/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import unocss_MzCDxu9LMj from "/root/code-vivasport/vs2-front/.nuxt/unocss.mjs";
import chunk_reload_client_UciE0i6zes from "/root/code-vivasport/vs2-front/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import apexchart_client_5d6ra58DX6 from "/root/code-vivasport/vs2-front/plugins/apexchart.client.ts";
import datetime_picker_client_zslymqXsrS from "/root/code-vivasport/vs2-front/plugins/datetime-picker.client.ts";
import loading_GxQ2Z9Goxa from "/root/code-vivasport/vs2-front/plugins/loading.ts";
import reservation_socket_client_vkiCY6EQFu from "/root/code-vivasport/vs2-front/plugins/reservation-socket.client.ts";
import toast_client_9z8IIRO0Dx from "/root/code-vivasport/vs2-front/plugins/toast.client.ts";
import vue_json_pretty_mZKxDYC2fj from "/root/code-vivasport/vs2-front/plugins/vue-json-pretty.ts";
import vue_trend_chart_GTuXh9Ns8x from "/root/code-vivasport/vs2-front/plugins/vue-trend-chart.ts";
import pwa_client_ZuYw5i1i7i from "/root/code-vivasport/vs2-front/node_modules/@vite-pwa/nuxt/dist/runtime/plugins/pwa.client.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  check_outdated_build_client_8vK7RkfGxZ,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  pwa_icons_plugin_LnrhIJeMG7,
  plugin_ghbUAjaD3n,
  i18n_yfWm7jX06p,
  unocss_MzCDxu9LMj,
  chunk_reload_client_UciE0i6zes,
  apexchart_client_5d6ra58DX6,
  datetime_picker_client_zslymqXsrS,
  loading_GxQ2Z9Goxa,
  reservation_socket_client_vkiCY6EQFu,
  toast_client_9z8IIRO0Dx,
  vue_json_pretty_mZKxDYC2fj,
  vue_trend_chart_GTuXh9Ns8x,
  pwa_client_ZuYw5i1i7i
]